import { hideableValueGetVisibleValue } from "@wix/devzai-utils-common";
import type { HideableValue } from "@wix/devzai-utils-common";
import React, {useMemo} from 'react';
import {classes, style} from './doppe-email-subscription-consent-element.st.css';
import {Checkbox, Icon, reactCreateMemo} from '@wix/devzai-utils-react';
import {CommonClasses, FlexLayout} from '@wix/devzai-common-client';
import IconChecked from '../subscribe-action-form/icons/checked.svg';
import {bymoPageContextPropsResolveConsentDisplayName, useBymoPageContextProps} from '../../doppe-sdk';
import {useDoppeViewerLocales} from "../../client/doppe-viewer-locales/doppe-viewer-locales";

export namespace DoppeMarketingConsentElement {
    export interface Props {
        customText: HideableValue<string>;
        showCheckbox?: boolean;
        onChange?: (value: boolean) => void;
        value?: boolean;
        hasError?: boolean;
    }
}

export const DoppeEmailSubscriptionConsentElement = reactCreateMemo(function DoppeMarketingConsentElement(
    props: DoppeMarketingConsentElement.Props,
) {
    const {
        customText,
        onChange,
        value,
        showCheckbox,
        hasError,
    } = props;

    const bymoPageContextProps = useBymoPageContextProps();
    const consentDisplayName = bymoPageContextPropsResolveConsentDisplayName(bymoPageContextProps);

    const doppeViewerLocales = useDoppeViewerLocales();

    const text = useMemo(() => {
        const customTextValue = hideableValueGetVisibleValue(customText, '').trim();
        if (customTextValue) {
            return customTextValue;
        } else if (showCheckbox) {
            return doppeViewerLocales['subscribeCheckBoxText']({
                username: consentDisplayName,
            });
        } else {
            return doppeViewerLocales['subscribeConsentText']({
                username: consentDisplayName,
            });
        }
    }, [customText, showCheckbox, consentDisplayName]);

    return (
        <div className={style(classes.consentBox, { hasError: hasError })}>
            <div className={style(classes.consentBoxContainer, FlexLayout.row.alignToTop)}>
                {showCheckbox ? (
                    <Checkbox
                        className={style(classes.consentCheckbox)}
                        checked={value}
                        onCheckedChanged={onChange}
                    >
                        {(renderProps) => {
                            return (
                                <div className={style(classes.consentCheckboxView, {}, FlexLayout.centerContent, CommonClasses.button)}>
                                    {renderProps.checked ? <Icon icon={IconChecked} /> : null}
                                </div>
                            );
                        }}
                    </Checkbox>
                ) : null}
                <div className={style(classes.consentText, FlexLayout.row.alignToTop, CommonClasses.button)}
                    onClick={onChange ? () => onChange(!value) : undefined}
                >
                    {text}
                </div>
            </div>
            {hasError ? (
                <div className={style(classes.inputErrorMessage, {})}>{doppeViewerLocales['youMustAgree']}</div>
            ) : null}
        </div>
    );
});
